"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobApplicationSchema = void 0;
const zod_1 = require("zod");
const job_enum_1 = require("./job.enum");
exports.JobApplicationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    candidateId: zod_1.z.string(),
    jobId: zod_1.z.string(),
    status: job_enum_1.JobApplicationStatusEnum,
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
